import { Component, OnInit, Input } from 'angular-ts-decorators';

import { ChartColors } from '@core/app/scripts/services/chart-colors';

/**
 * Simple component for showing line chart
 *
 * # Example
 * <pre>
 *   <line-chart></line-chart>
 * </pre>
 */
@Component({
  selector: 'lineChart',
  template: require('./line-chart.html').default,
})
export class LineChartComponent implements OnInit {
  @Input() data: any; // array of data arrays
  @Input() labels: any; // x axis note
  @Input() series: any; // series name
  @Input() legend: boolean; // if the legend should be shown, default to true

  public options = {
    scales: {
      yAxes: [
        {
          ticks: {
            // Include a dollar sign in the ticks
            callback: (value) => this.swCurrencyFilter(value),
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem) => this.swCurrencyFilter(tooltipItem.yLabel),
      },
    },
    legend: { display: false },
  };

  public datasetOverride = [
    {
      tension: 0,
    },
    {
      tension: 0,
    },
  ];

  constructor(
    public chartColors: ChartColors,
    private swCurrencyFilter,
  ) {
    'ngInject';
  }

  ngOnInit() {
    if (this.legend !== undefined) {
      this.options.legend = { display: this.legend };
    } else {
      this.options.legend = { display: true };
    }
  }
}
